import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

function PassoGuard({ children }) {
  const account = useSelector((state) => state.account);
  const rolename = account?.user?.roles[0]?.name?.trim() ?? "";

  if (!account.user) {
    return <Redirect to="/login" />;
  }

  if (rolename !== "passo") {
    if (rolename === "masso") {
      return <Redirect to="/masso" />;
    }

    if (rolename === "admin") {
      return <Redirect to="/administrator" />;
    }

    if (rolename === "report analyst assessor") {
      return <Redirect to="/report-analyst-assessor" />;
    }

    if (rolename === "report analyst treasurer") {
      return <Redirect to="/report-analyst-treasurer" />;
    }

    if (rolename === "provencial report analyst assessor") {
      return <Redirect to="/provencial-report-analyst-assessor" />;
    }

    if (rolename === "provencial report analyst treasurer") {
      return <Redirect to="/provencial-report-analyst-treasurer" />;
    }

    return <Redirect to="/app" />;
  }

  return children;
}

PassoGuard.propTypes = {
  children: PropTypes.any,
};

export default PassoGuard;
